'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const BannerLinks = renderWithRef('BannerLinks', null, (e, o)=>{
    let { children: s } = e;
    return jsx(RenderComp, {
        root: "div",
        forwardedRef: o,
        classNames: [
            'swan-banner-links'
        ],
        props: e,
        children: s
    });
});

export { BannerLinks };
